export const paginationSettings = {
  bannedWorker: {
    prefix: "bannedWorker",
    defaultPageSize: 10,
  },
  preferredWorker: {
    prefix: "preferredWorker",
    defaultPageSize: 10,
  }
};